import React from "react";
import { Button } from "../../ui/Button";

interface BackupHeaderProps {
  onCreateBackup: () => void;
  onImportBackup: () => void;
  isLoading: boolean;
  showTitle?: boolean;
}

export const BackupHeader: React.FC<BackupHeaderProps> = ({
  onCreateBackup,
  onImportBackup,
  isLoading,
  showTitle = true,
}) => {
  return (
    <div className="mb-6">
      {showTitle && (
        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          Backup Manager
        </h2>
      )}

      <div className="flex gap-3">
        <Button
          variant="primary"
          onClick={onCreateBackup}
          disabled={isLoading}
          className="flex items-center gap-2"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          Create Backup
        </Button>

        <Button
          variant="secondary"
          onClick={onImportBackup}
          disabled={isLoading}
          className="flex items-center gap-2"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
            />
          </svg>
          Import Backup
        </Button>
      </div>
    </div>
  );
};
